(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[9933],{

/***/ 223:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/our-difference",
      function () {
        return __webpack_require__(2943);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 2943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ OurDifference; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(5893);
// EXTERNAL MODULE: ./node_modules/next-seo/lib/next-seo.module.js
var next_seo_module = __webpack_require__(2962);
// EXTERNAL MODULE: ./src/components/common/index.ts + 9 modules
var common = __webpack_require__(108);
// EXTERNAL MODULE: ./src/components/common/icons/index.ts + 9 modules
var icons = __webpack_require__(9257);
// EXTERNAL MODULE: ./src/ui/index.ts + 16 modules
var ui = __webpack_require__(4522);
;// CONCATENATED MODULE: ./src/components/ourDifference/bookconsultation.tsx


var Consultation = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "m-auto grid w-[90%] grid-cols-1 gap-8 py-10 text-center text-base lg:w-[60%]",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* TextBold */.DU, {
                className: "text-center text-lg",
                children: "Ready for your dog to benefit from the Tucker Tub Difference? Book a free consultation to get a customised feeding plan."
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* ButtonWithArrow */.Ub, {
                href: "/consultation",
                center: true,
                buttonVariant: "primary",
                className: "m-auto w-[100%] lg:max-w-[240px]",
                children: "Book Consultation"
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/ourDifference/layout/body.tsx




var InfoCardData = [
    {
        id: "1",
        heading: "Farm Fresh & Local",
        subheading: "Australian owned and operated.",
        description: "We go one step further than Aussie made. We source ingredients from local farms in country Victoria that don't use any preservatives or chemicals in their product. It's as fresh as it gets!",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* AustraliaMapIcon */.yf, {})
    },
    {
        id: "2",
        heading: "Crafted With Care",
        subheading: "Tucker Tub is made with love, backed by expertise.",
        description: "Your pup's health matters to us. Our 25 years of experience is in each recipe, approved by\n      seasoned vets and our very own in-house pet nutritionists.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* RedHeartIcon */.T0, {})
    },
    {
        id: "3",
        heading: "Tailored Just For Them",
        subheading: "Each dog is unique and so are their dietary needs.",
        description: "There's no other dog quite like yours! We have dedicated specialists and in-house           pet nutritionists to create a tailored meal plan for your pup. We'll help you discover what\n      foods they thrive on.",
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(icons/* PawIcon */.b_, {})
    }
];
var CheckListData = [
    {
        id: "1",
        title: "Improved immune system"
    },
    {
        id: "2",
        title: "Boosted metabolism"
    },
    {
        id: "3",
        title: "Healthy digestion"
    },
    {
        id: "4",
        title: "Weight maintenance"
    },
    {
        id: "5",
        title: "Healthy, shiny coat"
    }
];
var BodyContent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: "h-full w-full bg-colorEight py-20 font-haboro-soft text-colorFifteen",
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Wrapper */.im, {
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "m-auto grid grid-cols-1 gap-[30px] sm:grid-cols-2",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Text */.xv, {
                                className: "text-title font-bold",
                                children: "Naturally Nutritious"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Text */.xv, {
                                children: "Tucker Tub is 100% natural - and so much more\u2026"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Text */.xv, {
                                children: "We pay special attention to essential ingredients like proteins, vitamins and amino acids while keeping out all the additives, preservatives and chemicals."
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Text */.xv, {
                                children: "You can think of Tucker Tub as superfood for your pup. "
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "w-full",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "text-base",
                                children: "Your dog gets the highly-nutritious ingredients it needs which may help provide the following benefits:"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "space-y-3.5 pt-5",
                                children: CheckListData.map(function(item) {
                                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* CheckList */.Su, {
                                        title: item.title
                                    }, item.id);
                                })
                            })
                        ]
                    }),
                    InfoCardData.map(function(card) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* InfoCard */.rJ, {
                            cardData: card
                        }, card.id);
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Consultation, {})
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./src/ui/cursive-basic.tsx
var cursive_basic = __webpack_require__(4693);
;// CONCATENATED MODULE: ./src/components/ourDifference/layout/head.tsx



var HeadContentCheckListData = [
    {
        id: "1",
        title: "100% natural ingredients"
    },
    {
        id: "2",
        title: "No fillers, preservatives or additives"
    },
    {
        id: "3",
        title: "Rich in vital nutrients "
    },
    {
        id: "4",
        title: "Reduces need for supplements"
    },
    {
        id: "5",
        title: "Recommended by vets and pet nutritionists"
    },
    {
        id: "6",
        title: "Locally sourced, farm fresh"
    },
    {
        id: "7",
        title: "Premium quality at affordable prices"
    }
];
var HeadContent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* BackgroundWrap */.e_, {
        className: "h-full w-full bg-meat",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* GradientWrap */.Mx, {
            className: "from-colorEight via-colorEight to-transparent",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* CurveBanner */.kq, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Header */.h4, {
                        className: "text-colorFourteen",
                        children: "Our Difference"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(ui/* Wrapper */.im, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "h-[200px]"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "py-20 w-[100%] lg:w-[90%]",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* Title */.Dx, {
                                    className: "text-colorFifteen",
                                    children: "The Tucker Tub Difference"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(cursive_basic/* CursiveBasic */.x, {
                                    children: "100% real ingredients, no fillers"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "py-[30px] text-colorFifteen",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* HeroText */.ls, {
                                        children: "Big brand pet food manufacturers often use fillers that can be harmful for your dog's digestive system. We've been using only the best natural ingredients to make nutritious, healthy dog food since 1996. We learnt exactly what dogs need and what they love."
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "space-y-3.5",
                                    children: HeadContentCheckListData.map(function(item) {
                                        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ui/* CheckList */.Su, {
                                            title: item.title
                                        }, item.id);
                                    })
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};

;// CONCATENATED MODULE: ./src/components/ourDifference/index.tsx



var OurDifferenceContent = function() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(HeadContent, {}),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(BodyContent, {})
        ]
    });
};

;// CONCATENATED MODULE: ./src/pages/our-difference/index.tsx




function OurDifference() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(next_seo_module/* NextSeo */.PB, {
                title: "Our Difference | Tucker Tub",
                description: "Tucker Tub's Our Difference",
                openGraph: {
                    title: "Our Difference | Tucker Tub",
                    description: "Tucker Tub's Our Difference",
                    url: "https://preview.tuckertub.com.au",
                    type: "website",
                    locale: "en_AU",
                    site_name: "Tucker Tub"
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(common/* Layout */.Ar, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(OurDifferenceContent, {})
            })
        ]
    });
};


/***/ }),

/***/ 4693:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ CursiveBasic; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(5893);

var CursiveBasic = function(param) {
    var children = param.children, _className = param.className, className = _className === void 0 ? "" : _className;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "m-auto font-madelyn text-sliderTitle text-colorSixteen lg:text-blockHeader ".concat(className),
        children: children
    });
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4507,236,5812,8969,9774,2888,179], function() { return __webpack_exec__(223); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);